<div class="profile button-drop-down" ngbDropdown *transloco="let translate">
  @if (user(); as user) {
    <div class="profile_data" ngbDropdownToggle>
      <p class="profile_name mb-0">{{ user.fullName }}</p>
    </div>
    <app-user-avatar
      ngbDropdownToggle
      class="profile_logo"
      [firstName]="user.firstName"
      [lastName]="user.lastName"
      [userId]="user.userId || ''">
    </app-user-avatar>
    <div ngbDropdownMenu class="button-drop-down-menu">
      <button
        data-testid="link_view_profile_header_user_menu"
        ngbDropdownItem
        [routerLinkActive]="['main_menu--active']"
        [routerLink]="['settings/profile']">
        <span>{{ translate("viewProfile") }}</span>
      </button>
      @if (isEnterprise()) {
        <a
          ngbDropdownItem
          data-testid="link_support_header_user_menu"
          [routerLink]="['/knowledge-base']"
          class="support-link">
          <span>{{ translate("support") }}</span>
          <svg>
            <use xlink:href="#support"></use>
          </svg>
        </a>
      }
      <button data-testid="btn_contact_support_header_user_menu" ngbDropdownItem (click)="openSupportRequest()">
        <span>{{ translate("contactSupport") }}</span>
        <svg>
          <use xlink:href="#support-chat"></use>
        </svg>
      </button>
      <button class="log-out" data-testid="link_log_out_header_user_menu" ngbDropdownItem (click)="logout()">
        <span>{{ translate("logOut") }}</span>
        <svg>
          <use xlink:href="#log-out"></use>
        </svg>
      </button>
    </div>
  }
</div>
